var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-lobby",
      style: { backgroundImage: "url(" + _vm.backgroundImage + ")" }
    },
    [
      _c("div", { staticClass: "page-lobby__content" }, [
        _c("div", {
          ref: "lobbyBox",
          staticClass: "lobby",
          style: {
            backgroundImage: "url('" + _vm.preloaderBackgroundImage + "')"
          },
          attrs: { id: "lobbyBox" }
        }),
        !_vm.isMobile
          ? _c("div", { staticClass: "lobby-right" }, [
              _c("div", { staticClass: "lobby-info" }, [
                _vm.winnerListEnabled
                  ? _c(
                      "div",
                      { staticClass: "lobby-info__nav" },
                      [
                        _c(
                          "v-btn",
                          {
                            class: {
                              active:
                                _vm.tabsDialog === 1 || !_vm.winnerListEnabled
                            },
                            on: {
                              click: function($event) {
                                _vm.tabsDialog = 1
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("front.game.titles.game_info")) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm.winnerListEnabled
                          ? _c(
                              "v-btn",
                              {
                                class: { active: _vm.tabsDialog === 2 },
                                on: {
                                  click: function($event) {
                                    _vm.tabsDialog = 2
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t("front.game.titles.recent_winners")
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "lobby-info__tabs" }, [
                  _vm.tabsDialog === 1 || !_vm.winnerListEnabled
                    ? _c(
                        "div",
                        { staticClass: "tab" },
                        [
                          _c("picture", [
                            _c("source", {
                              attrs: {
                                srcset:
                                  _vm.game.coverImage &&
                                  _vm.game.coverImage.webp,
                                type: "image/webp"
                              }
                            }),
                            _c("img", {
                              ref: "image",
                              attrs: {
                                src:
                                  _vm.game.coverImage &&
                                  _vm.game.coverImage.jpg,
                                alt: _vm.game.title
                              }
                            })
                          ]),
                          _c("h1", [_vm._v(_vm._s(_vm.game.title))]),
                          _c("h2", [_vm._v(_vm._s(_vm.game.platformTitle))]),
                          _c(
                            "vue-custom-scrollbar",
                            {
                              staticClass: "scroll-area",
                              attrs: { settings: _vm.scrollbarSettings }
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.gameDescription)
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tabsDialog === 2 && _vm.winnerListEnabled
                    ? _c(
                        "div",
                        { staticClass: "tab winner-list" },
                        [
                          _c("widget-winner", {
                            attrs: { "winners-per-view": 9 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm.relatedGames.length && !_vm.isMobile
        ? _c("div", { staticClass: "page-lobby__suggested" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("front.game.titles.suggested_games")))
            ]),
            _c(
              "div",
              { staticClass: "page-lobby__suggested-slider" },
              [
                _c(
                  "swiper",
                  _vm._b(
                    {
                      ref: "swiperSS",
                      staticClass: "suggested-slider",
                      attrs: { options: _vm.sliderSettings }
                    },
                    "swiper",
                    _vm.sliderSettings,
                    false
                  ),
                  _vm._l(_vm.relatedGames, function(item, index) {
                    return _c(
                      "swiper-slide",
                      { key: index, staticClass: "listGame__list-item" },
                      [_c("game-item", { attrs: { item: item } })],
                      1
                    )
                  }),
                  1
                ),
                _c("div", {
                  staticClass: "swiper-button-next swiper-button-white",
                  attrs: { id: "button-next-relacionados" },
                  on: {
                    click: function($event) {
                      return _vm.swiperNext()
                    }
                  }
                }),
                _c("div", {
                  staticClass: "swiper-button-prev swiper-button-white",
                  attrs: { id: "button-prev-relacionados" },
                  on: {
                    click: function($event) {
                      return _vm.swiperPrev()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.game
        ? _c("script", {
            attrs: { type: "application/ld+json" },
            domProps: { innerHTML: _vm._s(_vm.jsonLdReviewType) }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }